import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

// Check if Datadog RUM should be enabled
const isDatadogEnabled = () => {
  return process.env.REACT_APP_DD_RUM_ENABLED === 'true'
}

// Safe wrapper for datadogRum methods
const ddRum = {
  init: (config) => {
    if (isDatadogEnabled()) {
      datadogRum._setDebug(process.env.DD_ENV === 'development')
      datadogRum.init({ ...config, plugins: [...(config.plugins || []), reactPlugin()] })
    }
  },

  startView: (options) => {
    if (isDatadogEnabled()) {
      datadogRum.startView(options)
    }
  },

  setUser: (userInfo) => {
    if (isDatadogEnabled()) {
      datadogRum.setUser(userInfo)
    }
  },

  clearUser: () => {
    if (isDatadogEnabled()) {
      datadogRum.clearUser()
    }
  },

  addError: (error, context) => {
    if (isDatadogEnabled()) {
      datadogRum.addError(error, context)
    }
  },

  isEnabled: isDatadogEnabled
}

export default ddRum
